interface Props {
  primary: string;
  confidence: number;
  scores: { negative: number; neutral: number; positive: number };
}

const SEGMENTS: Array<{
  key: keyof Props['scores'];
  label: string;
  varName: string;
}> = [
  { key: 'negative', label: 'Negative', varName: 'var(--color-danger)' },
  { key: 'neutral', label: 'Neutral', varName: 'var(--text-muted)' },
  { key: 'positive', label: 'Positive', varName: 'var(--accent-emeraude)' },
];

export default function SentimentBar({ primary, confidence, scores }: Props) {
  const total = SEGMENTS.reduce((sum, s) => sum + (scores[s.key] || 0), 0) || 1;

  // Inner content only; SectionShell supplies the `sentiment` anchor + eyebrow.
  return (
    <div className="POST__ANALYSIS__sentiment">
      <div className="POST__ANALYSIS__sentiment__head">
        <span className={`POST__ANALYSIS__pill pill-${primary.toLowerCase()}`}>
          {primary}
        </span>
        <span className="POST__ANALYSIS__sentiment__conf">
          {Math.round(confidence * 100)}% confidence
        </span>
      </div>
      <div
        className="POST__ANALYSIS__sentiment__bar"
        role="img"
        aria-label={`Sentiment: ${SEGMENTS.map((s) => `${s.label} ${Math.round((scores[s.key] / total) * 100)}%`).join(', ')}`}
      >
        {SEGMENTS.map((s) => {
          const pct = ((scores[s.key] || 0) / total) * 100;
          if (pct <= 0) return null;
          return (
            <div
              key={s.key}
              className="POST__ANALYSIS__sentiment__seg"
              style={{ width: `${pct}%`, background: s.varName }}
              title={`${s.label} ${Math.round(pct)}%`}
            />
          );
        })}
      </div>
      <div className="POST__ANALYSIS__sentiment__legend">
        {SEGMENTS.map((s) => (
          <span key={s.key}>
            <span className="swatch" style={{ background: s.varName }} />
            {s.label} · {Math.round(((scores[s.key] || 0) / total) * 100)}%
          </span>
        ))}
      </div>
    </div>
  );
}
